import React, {useEffect, useState} from "react";
import axios from "axios";
import {DataGrid, GridToolbar} from '@mui/x-data-grid';
import {Link} from 'react-router-dom';
import {baseUrl} from '../Univ.js';
function IndentDrugList() {
    const [pharmviewData, setpharmviewData] = useState([]);
    const [rows, setRows] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        fetchpharmviewData();
    }, []);
    function fetchpharmviewData() {
        setIsLoading(true);
        axios.get(`${baseUrl}indent-pharm-search/?qty=gt0`)
            .then(response => {
                setpharmviewData(response.data);
                setIsLoading(false);
            })
            .catch(error => {
                console.log(error);
                setIsLoading(false);
            });
    }
    useEffect(() => {
        if (pharmviewData.length > 0) {
            const updatedRows = pharmviewData.map((item) => ({
                ...item,
                product: item.product.product,
                batch: item.product.batch,
                schedule: item.product.schedule,
                hsn: item.product.hsn,
                type: item.product.type,
                pack: item.product.pack,
                expiry: item.product.expiry,
                mrp: item.product.mrp,
                pprice: item.product.pprice,
            }));
            setRows(updatedRows);
        }
    }, [pharmviewData]);
    const columns = [
        {field: 'id', headerName: 'ID', width: 60},
        {field: 'dept', headerName: 'Raised to', width: 110},
        {field: 'user', headerName: 'User', width: 80},
        {field: 'product', headerName: 'Product', width: 250},
        {field: 'hsn', headerName: 'HSN', width: 120},
        {field: 'schedule', headerName: 'Schedule', width: 120},
        {field: 'batch', headerName: 'Batch', width: 120},
        {field: 'pack', headerName: 'Pack', width: 50},
        {field: 'qty', headerName: 'Qty', width: 50},
        {field: 'expiry', headerName: 'Expiry', width: 100},
        {field: 'mrp', headerName: 'MRP', width: 80},
        {field: 'pprice', headerName: 'Pur.Price', width: 80},
        {
            field: 'action', headerName: 'Action',
            renderCell: (params) => (
                <Link target="_blank" to={`/edit-indent/${params.row.id}/`} className="btn btn-warning">
                    Edit
                </Link>
            ),
            width: 80,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
        },
    ];
    return (
        <section className="container mt-4">
            <div className="row">
                <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
                    <i className="fa-solid fa-list" aria-hidden="true" style={{color: 'red'}}></i>
                    Indent Drug List
                </h3>
                {!isLoading && pharmviewData.length > 0 ? (
                    <div style={{height: '100%', width: '100%'}} className="mt-4">
                        <DataGrid
                            sx={{
                                boxShadow: 4,
                                border: 4,
                                borderColor: 'primary.light',
                                '& .MuiDataGrid-cell:hover': {
                                    color: 'primary.main',
                                },
                            }}
                            rows={rows}
                            columns={columns}
                            pageSize={10}
                            slots={{toolbar: GridToolbar}}
                            autoHeight
                        />
                    </div>
                ) : (
                    <>loading pls wait....</>
                )}
            </div>
        </section>
    );
}
export default IndentDrugList;
